import { Button, Stack, Typography } from "@mui/material";
import Label from "src/components/Label";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const AuthenticationRow = () => {
	const { translate } = useLocales();
	return (
		<Stack
			sx={{ mt: 2 }}
			flexDirection={{ xs: "column", sm: "row" }}
			alignItems={{ xs: "flex-start", sm: "center" }}
			justifyContent={"space-between"}
		>
			<Stack>
				<Stack flexDirection={"row"} alignItems={"center"}>
					<Typography variant='subtitle1'>{translate("profile.app_auth")}</Typography>
					<Label sx={{ ml: 2 }} color='primary'>
						{translate("profile.soon")}
					</Label>
				</Stack>
				<Typography variant='body2' color='text.secondary'>
					{translate("profile.2fa_description_2")}
				</Typography>
			</Stack>
			<Button variant='contained' disabled sx={{ mt: { xs: 4, sm: 0 } }}>
				{translate("profile.enable")}
			</Button>
		</Stack>
	);
};

export default AuthenticationRow;
